let CityService = function (Restangular) {
  const Service = Restangular.all('admin/city');

  let count = (query) => {
    return Service.customGET('count', query);
  }

  let save = (city) => {
    if (city.save) {
        return city.save();
    } else {
        return Service.post(city);
    }
  }

  let index = (query) => {
    return Service.getList(query);
  }

  let listCitiesWithClient = (query) => {
    return Service.customGET('clients', query);
  }
  let load = (query) => {
    query.deleted_at = 'null';
    return new Promise((resolve, reject) => {
        count(query)
        .then(response => {
            let count = response[0];
            index(query)
            .then(data => {
                resolve({count, data});
            })
            .catch(err => {
                reject(err);
            });
        })
        .catch(err => {
            reject(err);
        });
    });
  }

  let show = (id) => {
    return Service.get(id);
  }

  let destroy = (city) => {
    city.deleted_at = moment();
    return city.save();
  }

  return { index, load, save, show, destroy, listCitiesWithClient } ;
};

CityService.$inject = ['Restangular'];

export default CityService;



// WEBPACK FOOTER //
// ./client/app/components/city/city.service.js